import { render, staticRenderFns } from "./StrandHeader.vue?vue&type=template&id=6084fddd&scoped=true&"
import script from "./StrandHeader.vue?vue&type=script&lang=js&"
export * from "./StrandHeader.vue?vue&type=script&lang=js&"
import style0 from "./StrandHeader.vue?vue&type=style&index=0&id=6084fddd&prod&scoped=true&lang=css&"
import style1 from "./StrandHeader.vue?vue&type=style&index=1&id=6084fddd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6084fddd",
  null
  
)

export default component.exports